import * as actionTypes from './actionTypes';

export const fetchUserAnalyticsSuccess = (val) => {
  return {
    type: actionTypes.STORE_USERS_ANALYTICS_DATA,
    val: val
  }
}

export const fetchToolkitAnalyticsSuccess = (val) => {
  return {
    type: actionTypes.STORE_TOOLKIT_ANALYTICS_DATA,
    val: val
  }
}

export const fetchChartAnalyticsSuccess = (val) => {
  return {
    type: actionTypes.STORE_CHART_ANALYTICS_DATA,
    val: val
  }
}

export const fetchActionsAnalyticsSuccess = (val) => {
  return {
    type: actionTypes.STORE_ACTIONS_ANALYTICS_DATA,
    val: val
  }
}

export const fetchStoriesAnalyticsSuccess = (val) => {
  return {
    type: actionTypes.STORE_STORIES_ANALYTICS_DATA,
    val: val
  }
}

export const fetchUserMetrices = () => {
  return {
    type: actionTypes.FETCH_USERS_METRICES_LIST
  }
}

export const fetchToolkitMetrices = () => {
  return {
    type: actionTypes.FETCH_TOOLKIT_MATRICS_LIST
  }
}

export const fetchChartMetrices = () => {
  return {
    type: actionTypes.FETCH_CHART_MATRICS_LIST
  }
}

export const fetchActionsMetrices = () => {
  return {
    type: actionTypes.FETCH_ACTIONS_METRICES_LIST
  }
}

export const fetchStoriesMetrices = () => {
  return {
    type: actionTypes.FETCH_STORIES_MATRICES_LIST
  }
}
